module.exports = __webpack_public_path__ + "static/media/bulb.ded6575e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/bulb.png
 ** module id = 1241
 ** module chunks = 0
 **/